import { createServerFn } from "@tanstack/react-start";
import { getRequest, getRequestHeader } from "@tanstack/react-start/server";
import { Environment, fetchQuery, graphql } from "relay-runtime";
import { z } from "zod";
import type { getClubByHostQuery } from "./__generated__/getClubByHostQuery.graphql";
import { relayNetwork } from "@/relay/network";

export const getCurrentHostUrl = createServerFn().handler(async () => {
	const request = getRequest();
	const incomingHost = getRequestHeader("apx-incoming-host");
	const xForwardedFor = getRequestHeader("x-forwarded-for");
	const host: string | undefined =
		process.env.APP_ENV === "development"
			? "teste.hypemygame.co"
			: [request.url, incomingHost, xForwardedFor].find(
					(h) =>
						h &&
						!h.includes("http://localhost") &&
						!h.includes("vercel.app") &&
						!z.ipv4().safeParse(h).success,
				);

	if (!host || z.ipv4().safeParse(host).success) {
		return null;
	}

	const hostUrl = new URL(host.includes("http") ? host : `https://${host}`);

	return hostUrl.host;
});

export const getClub = createServerFn()
	.inputValidator(z.object({ host: z.string() }))
	.handler(async ({ data: body }) => {
		const data = await fetchQuery<getClubByHostQuery>(
			new Environment({
				network: relayNetwork,
			}),
			graphql`
    		query getClubByHostQuery($host: String!) {
    		    clubByDomain(domain: $host) {
                id
                rawID
                name
                description
                slug
                visibility
                isMember
                active
                logo {
                  signedUrl
                }
                domains {
                  domain
                  enabled
                  status
                }
                themes {
                  variant
                  styles
                }
                permissions {
                    slug
                }
                previewImage {
                  signedUrl
                }
                favicon {
                  signedUrl
                }
            }
    		}
		`,
			{ host: body.host },
		).toPromise();

		if (!data?.clubByDomain) {
			throw new Error("club not found");
		}

		return data?.clubByDomain;
	});
